var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHippoSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 573.4 760.8",
    style: {
      enableBackground: "new 0 0 573.4 760.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7F2DDB;}\n\t.st1{fill:#FFFFFF;stroke:#FAC9FF;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#FAC9FF;}\n\t.st3{fill:#3F0074;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#3F0074;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000168083144169750766180000013169213138378055846_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_layer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.1,396.2H182.2c-62.6,0-143.6,48.1-143.6-14.5l30.2-221.7c0-62.6,50.8-113.4,113.4-113.4h0h200.8 c62.6,0,106.7,50.2,116.3,113.5l27.1,214.2C526.5,436.8,445.7,396.2,383.1,396.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.4,671.8l47.2,18.4c5.6,2.2,8.3,8.5,6.2,14l-18.4,47.2c-2.2,5.6-8.5,8.3-14,6.2l-47.2-18.4 c-5.6-2.2-8.3-8.5-6.2-14l18.4-47.2C109.6,672.3,115.8,669.6,121.4,671.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M484.7,736.5l-47.2,18.4c-5.6,2.2-11.9-0.6-14-6.2l-18.4-47.2c-2.2-5.6,0.6-11.9,6.2-14l47.2-18.4 c5.6-2.2,11.9,0.6,14,6.2l18.4,47.2C493.1,728.1,490.3,734.3,484.7,736.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M573.4,479.3v28.9c0,113.2-91.8,205.1-205.1,205.1h-55.8c-4.9,0.1-9.7-1-14.1-3.1c-7.5-3.7-12.2-9.7-16-14.2 c-1.1,1.3-2.3,2.5-3.6,3.7c-10,8.9-22.9,13.7-36.2,13.7h-37.5C91.8,713.3,0,621.5,0,508.3v-28.9c0-113.3,91.8-205.1,205.1-205.1 h163.2C481.6,274.2,573.4,366.1,573.4,479.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9951 -9.853760e-02 9.853760e-02 0.9951 -45.7517 14.8854)",
    className: "st3",
    cx: 127.8,
    cy: 470.6,
    rx: 27.9,
    ry: 27.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 448.2,
    cy: 471.3,
    r: 27.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M444.9,219c0,6.5-1.2,13-3.5,19.1c-0.8-29.9-25.7-53.5-55.6-52.7c-22,0.6-41.5,14.5-49.3,35.1 c0-0.5,0-1,0-1.5c-0.4-29.9,23.5-54.5,53.4-54.9c29.9-0.4,54.5,23.5,54.9,53.4C444.9,218,444.9,218.5,444.9,219L444.9,219z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M441.4,238.1c-10.6,28-41.8,42.2-69.8,31.6c-20.6-7.8-34.5-27.2-35.1-49.3c10.6-28,41.8-42.2,69.8-31.6 C426.9,196.6,440.8,216.1,441.4,238.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M233.7,207.8c-20.3-22-54.6-23.4-76.6-3.2c-13.9,12.8-20.2,32-16.4,50.6c-20.3-22-18.8-56.3,3.2-76.6 s56.3-18.8,76.6,3.2C227.2,189.1,231.7,198.1,233.7,207.8L233.7,207.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9008 -0.4343 0.4343 0.9008 -16.208 49.38)",
    className: "st0",
    cx: 100,
    cy: 60.2,
    rx: 40.6,
    ry: 54.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 187.3708 426.8372)",
    className: "st0",
    cx: 463.3,
    cy: 51.2,
    rx: 54.2,
    ry: 40.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M234.8,218.5c0,29.9-24.3,54.2-54.2,54.2c-15.1,0-29.5-6.3-39.8-17.4c-5.9-29.3,13-57.9,42.4-63.9 c18.6-3.8,37.8,2.5,50.6,16.4C234.4,211.3,234.8,214.9,234.8,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M146,139.6c9.6-16.7,30.4-23.3,47.9-15.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M380.1,124.7c16.1-10.7,37.6-7.3,49.6,7.8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHippoSvg);
export default __webpack_public_path__ + "static/media/HippoSVG.e97b57bd19191c10350c229730c4c496.svg";
export { ForwardRef as ReactComponent };